angular
  .module('contrast.rules.cve', [
    'ngRoute',
    'ngAnimate',
    'route-segment',
    'view-segment'
  ])
  .controller(
    'CveShieldCtrl',
    function (
      $scope,
      $timeout,
      $filter,
      $q,
      $interval,
      ChartService,
      ErrorService,
      ProtectionRulesFactory,
      PROTECT_RULES_EXPAND_BREAKDOWN_PROPERTIES
    ) {
      'ngInject'

      var _searchKeywords = ''
      var delay = 200 //ms to simulate the infinite scroll

      angular.extend($scope, {
        rules: [],
        filteredRules: [],
        model: {
          searchKeywords: searchKeywords,
          busy: true,
          row: 'name',
          totalDev: true,
          totalQa: true,
          totalProd: true
        },
        loadPromise: undefined,
        expandProperties: PROTECT_RULES_EXPAND_BREAKDOWN_PROPERTIES
      })

      angular.extend($scope, {
        order: order
      })

      function init() {
        loadRules()
      }

      function loadRules() {
        var params = {
          expand: $scope.expandProperties
        }

        $scope.loadPromise = ProtectionRulesFactory.getOnlyCveShields(
          params
        ).then(
          function (response) {
            $scope.rules = response.data.rules
            if ($scope.rules[0]) {
              for (var i = 0; i < $scope.rules.length; i++) {
                var rule = $scope.rules[i]
                rule.totalDev =
                  rule.development.total_blocking_apps +
                  rule.development.total_monitoring_apps +
                  rule.development.total_off_apps
                rule.totalQa =
                  rule.qa.total_blocking_apps +
                  rule.qa.total_monitoring_apps +
                  rule.qa.total_off_apps
                rule.totalProd =
                  rule.production.total_blocking_apps +
                  rule.production.total_monitoring_apps +
                  rule.production.total_off_apps

                rule.development.data = ChartService.buildProtectionModeData(
                  rule.development,
                  rule.totalDev
                )
                rule.qa.data = ChartService.buildProtectionModeData(
                  rule.qa,
                  rule.totalQa
                )
                rule.production.data = ChartService.buildProtectionModeData(
                  rule.production,
                  rule.totalProd
                )

                if (rule.totalDev > 0) {
                  $scope.model.totalDev = false
                }
                if (rule.totalQa > 0) {
                  $scope.model.totalQa = false
                }
                if (rule.totalProd > 0) {
                  $scope.model.totalProd = false
                }
              }
            }
            $scope.filteredRules = $filter('orderBy')(
              $scope.rules,
              $scope.model.row
            )
            $scope.model.busy = false
            $timeout(function () {
              $scope.$emit('triggerScrollCheck')
            })
          },
          function (response) {
            $scope.model.busy = false
            ErrorService.processError(response)
          }
        )
      }

      function searchKeywords(newSearchKeywords) {
        if (!arguments.length) {
          return _searchKeywords
        }

        if (newSearchKeywords !== _searchKeywords) {
          _searchKeywords = newSearchKeywords
        }
        $scope.model.busy = true
        applyFilters()

        return _searchKeywords
      }

      function order(rowName) {
        if ($scope.model.row === rowName) {
          return
        }
        $scope.model.busy = true
        $scope.model.row = rowName

        var deferred = $q.defer()
        $scope.promise = deferred.promise
        $interval(
          function () {
            $scope.filteredRules = applyFilters()
            deferred.resolve('')
          },
          delay,
          1
        )
      }

      function applyFilters() {
        $scope.filteredRules = $filter('orderBy')(
          $scope.rules,
          $scope.model.row
        )
        if (_searchKeywords.length > 0) {
          $scope.filteredRules = $filter('filter')(
            $scope.filteredRules,
            filterFunction,
            _searchKeywords
          )
        }
        $scope.model.busy = false
        return $scope.filteredRules
      }

      function filterFunction(rule) {
        return (
          rule.name
            .toLowerCase()
            .indexOf(_searchKeywords.toLowerCase() || '') !== -1 ||
          (rule.uuid ? rule.uuid.indexOf(_searchKeywords || '') !== -1 : false)
        )
      }

      init()
    }
  )
